import React from "react"
import Skeleton from "react-loading-skeleton"
import { trans } from "@/_providers/Translation"

function Cart(props) {
  const basket = props.basket
  const articles =
    basket && Array.isArray(basket.articles) ? basket.articles : []

  // transport_options is an object keyed by shipment code
  const transportOptions =
    basket && basket.transport_options
      ? Object.values(basket.transport_options)
      : []

  const money = (val) => Number(val || 0).toFixed(2)

  // shipment names may contain html markup - strip it for the <option> label
  const cleanName = (name) =>
    (name || "")
      .replace(/<[^>]*>/g, " ")
      .replace(/\s+/g, " ")
      .trim()

  const grandTotal = basket
    ? Number(basket.articles_total || 0) +
      Number(basket.shipping_costs || 0) +
      Number(basket.disposal_costs || 0) +
      Number(basket.extra_charges || 0)
    : 0

  return (
    <div className="pannel cart-box">
      <h3>{trans("catalogue.cart")}</h3>

      {props.loading ? (
        <Skeleton height={40} count={4} />
      ) : articles.length === 0 ? (
        <p>{trans("catalogue.emptyCart")}</p>
      ) : (
        <>
          {basket.order_id ? (
            <p
              style={{
                fontSize: "12px",
                color: "#8f9bba",
                marginTop: "-10px",
                marginBottom: "15px",
              }}
            >
              {trans("catalogue.orderId")}: {basket.order_id}
            </p>
          ) : (
            ""
          )}

          <div className="cart-items">
            {articles.map((article) => (
              <div className="cart-item" key={"cart-" + article.index}>
                <div className="cart-item-info">
                  <div className="cart-item-name">{article.name}</div>
                  <div className="cart-item-meta">
                    {article.number} · {trans("catalogue.quantity")}:{" "}
                    {article.quantity}
                  </div>
                </div>
                <div className="cart-item-side">
                  <div>{money(article.total_price)}</div>
                  <button
                    type="button"
                    className="button-small cart-item-remove"
                    disabled={props.removingIndex === article.index}
                    onClick={() => props.handleRemove(article.index)}
                  >
                    {trans("catalogue.remove")}
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="cart-totals">
            <div className="row">
              <span>{trans("catalogue.articlesTotal")}</span>
              <span>{money(basket.articles_total)}</span>
            </div>
            <div className="row">
              <span>{trans("catalogue.shipping")}</span>
              <span>{money(basket.shipping_costs)}</span>
            </div>
            {Number(basket.disposal_costs) > 0 && (
              <div className="row">
                <span>{trans("catalogue.disposal")}</span>
                <span>{money(basket.disposal_costs)}</span>
              </div>
            )}
            {Number(basket.extra_charges) > 0 && (
              <div className="row">
                <span>{trans("catalogue.extraCharges")}</span>
                <span>{money(basket.extra_charges)}</span>
              </div>
            )}
            <div className="row grand">
              <span>{trans("catalogue.total")}</span>
              <span>{money(grandTotal)}</span>
            </div>
          </div>

          {transportOptions.length > 0 && (
            <div className="cart-shipping">
              <label>{trans("catalogue.shippingMethod")}</label>
              <select
                value={props.transportCode || ""}
                onChange={(e) => props.handleTransport(e.target.value)}
              >
                <option value="" disabled>
                  {trans("catalogue.shippingMethod")}
                </option>
                {transportOptions.map((option) => (
                  <option key={option.code} value={option.code}>
                    {cleanName(option.name)}
                  </option>
                ))}
              </select>
            </div>
          )}

          <button
            type="button"
            className="cart-complete button-primary"
            disabled={props.ordering || !props.transportCode}
            onClick={props.handleOrder}
          >
            {props.ordering
              ? trans("catalogue.ordering")
              : trans("catalogue.completeOrder")}
          </button>
        </>
      )}
    </div>
  )
}

export default Cart
